/**
 * 此处存放计算表格可视高度逻辑
 */
const MIN_HEIGHT = 240
const SPACE = 328
const _update = () => (window.innerHeight - SPACE < MIN_HEIGHT ? MIN_HEIGHT : window.innerHeight - SPACE)
export default {
    data() {
        return {
            tableHeight: _update(), // 表格可视化区域高度 自动计算
        }
    },
 
    mounted() {
        // 随着窗口高度的变化 计算表格可视区域的高度
        window.onresize = () => {
            this.tableHeight = _update()
        }
    },
}
